import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubble4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBubble4"><Path d="M21.002 3V20H7.96705L3.00195 23.1032V3H21.002Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubble4;
